import { useSetAtom } from "jotai";
import { Icon, Text } from "@zapier/design-system";
import { emitUserInteractionEventAtom } from "@zapier/canvas-state";
import styles from "./GuideBlock.module.css";

type Guide = {
  title: string;
  description: string;
  url: string;
};

type Props = {
  guide: Guide;
};

export function GuideBlock({ guide: { title, description, url } }: Props) {
  const emitUserInteractionEvent = useSetAtom(emitUserInteractionEventAtom);

  const handleButtonClick = async () => {
    window.open(url, "_blank");

    await emitUserInteractionEvent({
      eventAction: "click",
      interactionGoal: "Viewed a single guide",
      rawText: title,
    });
  };

  return (
    <button className={styles.root} onClick={handleButtonClick}>
      <div>
        <Icon name="fileGuide" color="UiPrimaryStronger" />
      </div>
      <div className={styles.textWrapper}>
        <Text type="Body3Multiline" color="TextDefault">
          {title}
        </Text>
        <Text type="SmallPrint1Multiline" color="TextWeaker" textAlign="left">
          {description}
        </Text>
      </div>
    </button>
  );
}
